export default "__VITE_ASSET__CTFgmhXx__"